import { useEffect, useState } from 'react';

export const DEVICE_SIZES = {
  MOBILE: 'mobile',
  TABLET_SM: 'tablet-sm',
  TABLET: 'tablet',
  TABLET_LG: 'tablet-lg',
  LAPTOP: 'laptop',
  DESKTOP: 'desktop'
};

export const isPhoneLayout = (device) =>
  device === DEVICE_SIZES.MOBILE || device === DEVICE_SIZES.TABLET_SM;

export const isPhone = (device) => device === DEVICE_SIZES.MOBILE;

export const isTabletOrNarrower = (device) =>
  device === DEVICE_SIZES.MOBILE ||
  device === DEVICE_SIZES.TABLET_SM ||
  device === DEVICE_SIZES.TABLET;

export const getDevice = (width) => {
  if (width <= 480) return DEVICE_SIZES.MOBILE;
  if (width <= 768) return DEVICE_SIZES.TABLET_SM;
  if (width <= 1024) return DEVICE_SIZES.TABLET;
  if (width <= 1280) return DEVICE_SIZES.TABLET_LG;
  if (width <= 1512) return DEVICE_SIZES.LAPTOP;
  return DEVICE_SIZES.DESKTOP;
};

export const useWindowSize = () => {
  const [size, setSize] = useState({
    device: getDevice(window.innerWidth),
    width: window.innerWidth,
    height: window.innerHeight
  });

  useEffect(() => {
    const handleResize = () => {
      setSize({
        device: getDevice(window.innerWidth),
        width: window.innerWidth,
        height: window.innerHeight
      });
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return { width: size.width, height: size.height, device: size.device };
};
